class MainHero {
    constructor() {
        // view
        this.name = 'main-hero';
        this.components = document.querySelectorAll(`.${this.name}`);

        if (this.components) {
            this.init();
        }
    }

    init() {
        this.components.forEach((comp) => {
            let sliderNode = comp.querySelector('.splide');
            if (!sliderNode) return;
            this.initSlider(sliderNode);
            let arrowDown = comp.querySelector('[data-comp="goToNextSection"]');
            if (!arrowDown) return;
            this.goToNextSection(arrowDown);
        });
    }
    initSlider(slider) {
        const sliderNode = new Splide(slider, {
            type: "loop",
            autoplay: true,
            arrows: false,
            pagination: true
        });
        sliderNode.mount();
    };
    goToNextSection(arrow) {
        arrow.addEventListener('click', function() {
            const nextSection = arrow.closest('.container').nextElementSibling;
            if(nextSection) {
                nextSection.scrollIntoView({ behavior: 'smooth' });
            }
        });
    }
}


const mainHero = new MainHero();
